import GenericRequest, { METHOD_POST } from '../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../shared/webservices/endpoint';

export default class DocumentsSchemasRequest extends GenericRequest {

    document_schema_type_id;
    term;
    page;

    constructor(document_schema_type_id, page, term) {
        super(METHOD_POST, ApiEndpoints.DOCUMENTS_SCHEMAS);
        this.document_schema_type_id = document_schema_type_id;
        this.page = page;
        this.term = term;
    }

    overrideRequest() {
        const request = {};
        request.criteria = {};
        if ( this.document_schema_type_id && this.document_schema_type_id !== 0 ) request.criteria.document_schema_type_ids = [this.document_schema_type_id];
        if ( this.page ) request.criteria.page = this.page;
        if ( this.term ) request.criteria.term = this.term;
        return request;
    }
}



// WEBPACK FOOTER //
// ./src/app/documents/ws/schemes/DocumentsSchemasRequest.js